export default __webpack_public_path__ + "static/supportImage-a54653a12e4f009dc3ef1ebb7c5cf89c.webp";